module.exports = __webpack_public_path__ + "static/img/235_TO8_1989.1068b6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/235_TO8_1989.jpg
// module id = sFjk
// module chunks = 0